export default "__VITE_ASSET__9mev2MlJ__"